import useSWR from 'swr'
import { GetSessionID } from '../Utility/SessionUtility';

/**
 * 国マスタ検索Hook
 * 対象年度の国マスタを取得する
 * @param year 対象年度
 */
export function useSearchCountryData(year?:string) {

    const fetchAddress = `/competition/api/management/searchcountrydata?targetYear=${year}&sessionId=${GetSessionID()}`;

    const fetcher = () => fetch(fetchAddress).then(res =>{ 
        return res.json()
    })
    .then(data => {
        return data.country_data;
    });

    const {data, error, isLoading, mutate} = useSWR(`SearchCountryData${year}`, fetcher, {revalidateOnFocus:false, revalidateOnReconnect:false});

    return{
        /**
         * 国マスタ配列
         */
        countryData: data,
        
        /**
         * ロード中フラグ
         */
        isLoading,

        /**
         * エラーフラグ
         */
        isError: error,

        /**
         * 再取得関数
         */
        mutate,
    }
}